(() => {
  const calculatorSelector = '[id^="box-calculator-"], #box-calculator';

  if (window.KyproBoxCalculator) {
    window.KyproBoxCalculator.init(document);
    return;
  }

  function escapeSelectorValue(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return String(value).replace(/"/g, '\\"');
  }

  function findQuantityInput(calc, productFormId) {
    if (productFormId) {
      const escapedFormId = escapeSelectorValue(productFormId);
      return (
        document.querySelector(`quantity-input input.quantity__input[form="${escapedFormId}"]`) ||
        document.querySelector(`input[name="quantity"][form="${escapedFormId}"]`)
      );
    }

    const productInfo = calc.closest('product-info') || calc.closest('.product');
    return (
      productInfo?.querySelector('quantity-input input.quantity__input') ||
      productInfo?.querySelector('input[name="quantity"]') ||
      document.querySelector('quantity-input input.quantity__input') ||
      document.querySelector('input[name="quantity"]')
    );
  }

  function init(root = document) {
    const calculators = root.querySelectorAll(calculatorSelector);
    if (!calculators.length) return;

    calculators.forEach((calc) => {
      if (calc.dataset.boxCalculatorInitialized === 'true') return;
      calc.dataset.boxCalculatorInitialized = 'true';

      const sectionId = calc.dataset.sectionId || '';
      const productFormId = calc.dataset.productFormId || '';
      const coverageFromData = parseFloat(calc.dataset.coverage || '0');
      const measurementUnit = calc.dataset.measurementUnit || 'sq ft';
      const coverageUnit = calc.dataset.coverageUnit || measurementUnit;

      const installEnabled = calc.dataset.installEnabled === 'true';
      const installRate = parseFloat(calc.dataset.installRate || '0');
      const installRateUnit = calc.dataset.installRateUnit || measurementUnit;
      const currencySymbol = calc.dataset.currencySymbol || '$';

      const areaInput =
        calc.querySelector(sectionId ? `#area-input-${sectionId}` : '#area-input');
      const wasteSelect =
        calc.querySelector(sectionId ? `#waste-select-${sectionId}` : '#waste-select');
      const boxesEl =
        calc.querySelector(sectionId ? `#boxes-needed-${sectionId}` : '#boxes-needed');
      const totalCovEl =
        calc.querySelector(sectionId ? `#total-coverage-${sectionId}` : '#total-coverage');
      const covEl = calc.querySelector('[data-cov]');
      const installToggle =
        calc.querySelector(sectionId ? `#install-toggle-${sectionId}` : '#install-toggle');
      const installEstimateEl =
        calc.querySelector(sectionId ? `#install-estimate-${sectionId}` : '#install-estimate');

      const propertyProjectSize =
        calc.querySelector(`#property-project-size-${sectionId}`);
      const propertyWaste =
        calc.querySelector(`#property-waste-${sectionId}`);
      const propertyCoveragePerBox =
        calc.querySelector(`#property-coverage-per-box-${sectionId}`);
      const propertyCoveragePerPiece =
        calc.querySelector(`#property-coverage-per-piece-${sectionId}`);
      const propertyBoxesNeeded =
        calc.querySelector(`#property-boxes-needed-${sectionId}`);
      const propertyPiecesNeeded =
        calc.querySelector(`#property-pieces-needed-${sectionId}`);
      const propertyTotalCoverage =
        calc.querySelector(`#property-total-coverage-${sectionId}`);
      const propertyInstallSelected =
        calc.querySelector(`#property-install-selected-${sectionId}`);
      const propertyInstallRate =
        calc.querySelector(`#property-install-rate-${sectionId}`);
      const propertyInstallEstimate =
        calc.querySelector(`#property-install-estimate-${sectionId}`);

      const qtyInput = findQuantityInput(calc, productFormId);

      function parseNumber(value) {
        const n = parseFloat(value);
        return Number.isFinite(n) ? n : 0;
      }

      function roundToTwo(num) {
        return Math.round(num * 100) / 100;
      }

      function getCoverage() {
        if (coverageFromData > 0) return coverageFromData;
        const n = Number((covEl?.textContent || '').replace(/[^0-9.]/g, ''));
        return Number.isFinite(n) ? n : 0;
      }

      function formatMoney(amount) {
        const locale = document.documentElement.lang || navigator.language || 'en';

        try {
          return `${currencySymbol}${new Intl.NumberFormat(locale, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(amount)}`;
        } catch (error) {
          return `${currencySymbol}${amount.toFixed(2)}`;
        }
      }

      function setPropertyValue(el, value) {
        if (el) el.value = value;
      }

      function recalc() {
        const area = Math.max(0, parseNumber(areaInput?.value));
        const wastePct = Math.max(0, parseNumber(wasteSelect?.value));
        const coverage = getCoverage();

        setPropertyValue(propertyWaste, wasteSelect ? `${wastePct}%` : '');

        if (propertyCoveragePerBox && coverage > 0) {
          propertyCoveragePerBox.value = String(coverage);
        }

        if (propertyCoveragePerPiece && coverage > 0) {
          propertyCoveragePerPiece.value = String(coverage);
        }

        if (propertyInstallRate && installRate > 0) {
          propertyInstallRate.value = `${formatMoney(installRate)} / ${installRateUnit}`;
        }

        if (!coverage) return;

        if (area <= 0) {
          if (boxesEl) boxesEl.textContent = '0';
          if (totalCovEl) totalCovEl.textContent = '0';

          if (installEstimateEl) {
            installEstimateEl.textContent = formatMoney(0);
          }

          setPropertyValue(propertyProjectSize, '');
          setPropertyValue(propertyBoxesNeeded, '');
          setPropertyValue(propertyPiecesNeeded, '');
          setPropertyValue(propertyTotalCoverage, '');
          setPropertyValue(propertyInstallSelected, installToggle?.checked ? 'Yes' : 'No');
          setPropertyValue(propertyInstallEstimate, '');

          return;
        }

        const needed = Math.ceil((area * (1 + wastePct / 100)) / coverage);
        const totalCoverage = roundToTwo(needed * coverage);

        if (boxesEl) boxesEl.textContent = String(needed);
        if (totalCovEl) totalCovEl.textContent = totalCoverage.toFixed(2);

        if (qtyInput) {
          qtyInput.value = Math.max(1, needed);
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        setPropertyValue(propertyProjectSize, `${roundToTwo(area).toFixed(2)} ${measurementUnit}`);
        setPropertyValue(propertyBoxesNeeded, String(needed));
        setPropertyValue(propertyPiecesNeeded, String(needed));
        setPropertyValue(propertyTotalCoverage, `${totalCoverage.toFixed(2)} ${coverageUnit}`);

        if (installEnabled && installRate > 0) {
          const installSelected = !!installToggle?.checked;
          const installEstimate = installSelected ? roundToTwo(area * installRate) : 0;

          if (installEstimateEl) {
            installEstimateEl.textContent = formatMoney(installEstimate);
          }

          setPropertyValue(propertyInstallSelected, installSelected ? 'Yes' : 'No');
          setPropertyValue(
            propertyInstallEstimate,
            installSelected ? formatMoney(installEstimate) : ''
          );
        }
      }

      areaInput?.addEventListener('input', recalc);
      wasteSelect?.addEventListener('change', recalc);
      installToggle?.addEventListener('change', recalc);

      recalc();
    });
  }

  window.KyproBoxCalculator = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
